import React, { lazy, useCallback, useEffect } from "react";

const Callback = lazy(() => import("./pages/callback"));

const IdentityRoutes = [
    { path: "callback", element: <Callback /> },
    { path: "pending", element: <Callback /> },
];

export default IdentityRoutes;
